import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import SingleDropdown from "../../components/SingleDropdown";
import MultiSelectDropdown from "../../components/MultiSelectDropdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import constant from "../../constant/constant";
import { useSelector } from "react-redux";

const AddTeam = ({ onClose, editedMember, getStudentList }) => {
  const user = useSelector((state) => state.auth);
  const [email, setEmail] = useState([]);
  const [department, SetDepartment] = useState("");
  const [role, setRole] = useState("");
  const [manager, setManager] = useState("");
  const [designation, setDesignation] = useState("");
  const isEmailInputDisabled = !!editedMember;
  const handleEmailChange = (newEmail) => {
    setEmail(newEmail);
  };

  useEffect(() => {
    if (editedMember) {
      setRole(editedMember.role || "");
      setManager(editedMember.manager || "");
      SetDepartment(editedMember.department || "");
      setDesignation(editedMember.designation || "");
      setEmail(
        editedMember.email
          ? editedMember.email.split(",").map((email) => email.trim())
          : []
      );
    } else {
      setRole("");
      setManager("");
      SetDepartment("");
      setEmail([]);
    }
  }, [editedMember]);

  const validateForm = () => {
    let isValid = true;
    if (email.length === 0) {
      toast.warn("At least one email address is required.");
      isValid = false;
    } else {
      email.forEach((e) => {
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(e.label)) {
          toast.warn("Invalid email address format.");
          isValid = false;
        }
      });
    }
    return isValid;
  };


  const handleSubmit = () => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/my_student.php?fun=getInvitationMail`,
      headers: {"Auth-Id": user.auth_id },
      data: { "company_id": user.userid, "email":email}
    }).then(function (response) {
      const data = response.data.data;
      if (data.status.length === data.msg.length) {
        data.status.forEach((status, index) => {
          if (status === "1") {
            toast.success(data.msg[index]);
            onClose();
            getStudentList();
          } else {
            toast.warn(data.msg[index]);
          }
        });
      }
    })
    .catch(function (error) {
    });
  };
  const optionsTags = [
    { label: "Tag 1", value: "Tag1" },
    { label: "Tag 2", value: "Tag2" },
    { label: "Tag 3", value: "Tag3" },
  ];
  return (
    <>
      <div className="add-team-details">
        <div className="mt16 df fdc">
          <label className="fc15 fw6 fs14 ls1 mb8">Email Address(es)</label>
          {editedMember ? (
            <input
              type="email"
              autoComplete="off"
              value={email}
              className={`${
                editedMember ? "disabled-input bg6" : ""
              } brd1 pl12 pt8 pb8 h40 br4`}
              disabled={isEmailInputDisabled}
            />
          ) : (
            <MultiSelectDropdown
              options={optionsTags}
              selectedOptions={email}
              onSelectedOptionsChange={handleEmailChange}
              showDropdown={false}
            />
          )}
        </div>
      </div>
      <div className="button-container mt32 df jce">
        <button type="button" className="btn-cancel" onClick={onClose}>
          Cancel
        </button>
        <button
          type="button"
          className="update-button btn-blue common-btn pl12 pr12 br24 fs14 cp ls1"
          onClick={handleSubmit}
        >
          {editedMember ? "Update" : "Send Invitation"}
        </button>
      </div>
      
      <ToastContainer position="bottom-right" />
    </>
  );
};

export default AddTeam;
